import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationRU from "./locales/ru.json";
import translationEN from "./locales/en.json";
import translationUZ from "./locales/uz.json";

export const LANGUAGE_STORAGE_KEY = "uztravelPreferredLanguage";

i18n

  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: translationRU },
      en: { translation: translationEN },
      uz: { translation: translationUZ },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: [],
    },
  });

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language?.split("-")[0] || "en";
  i18n.on("languageChanged", (language) => {
    document.documentElement.lang = language.split("-")[0];
  });
}

export default i18n;
